export default "__VITE_ASSET__ca222d10__"